import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserManagementFiltersState {
  startDate: string;
  endDate: string;
}

const initialState: UserManagementFiltersState = {
  startDate: "",
  endDate: "",
};

const userManagementFiltersSlice = createSlice({
  name: "userManagementFilters",
  initialState,
  reducers: {
    setUserManagementDateRange: (
      state,
      action: PayloadAction<{ startDate: string; endDate: string }>,
    ) => {
      state.startDate = action.payload.startDate;
      state.endDate = action.payload.endDate;
    },
    clearUserManagementDateRange: (state) => {
      state.startDate = "";
      state.endDate = "";
    },
  },
});

export const { setUserManagementDateRange, clearUserManagementDateRange } =
  userManagementFiltersSlice.actions;
export default userManagementFiltersSlice.reducer;
